import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { ErrorNotification } from 'app/components/error-notification/error-notification';
import { getErrorDetails } from 'app/shared/utils/get-error-details';
import { ErrorType } from 'app/shared/consts/error-translations';
import { useErrors } from 'app/shared/contexts/errors';

export const ErrorPage = (): JSX.Element => {
  const { formatMessage, messages } = useIntl();
  const { genericErrors, hideGenericErrors } = useErrors();
  const navigate = useNavigate();
  const handleClick = useCallback(() => {
    hideGenericErrors();
    navigate(-1);
  }, [navigate, hideGenericErrors]);

  const { titleTranslationId, descriptionTranslationId, buttonTextTranslationId } = getErrorDetails(
    genericErrors,
    messages,
    ErrorType.GENERIC_ERROR,
  );

  return (
    <div className="flex flex-col items-center justify-center p-4 h-screen w-screen">
      <ErrorNotification
        title={formatMessage({ id: titleTranslationId })}
        description={formatMessage({ id: descriptionTranslationId })}
        buttonText={formatMessage({ id: buttonTextTranslationId })}
        onClick={handleClick}
      />
    </div>
  );
};
